import { render } from "./B2bFiltersCommercialRelation.vue?vue&type=template&id=8ad4b76e&scoped=true&lang=pug"
import script from "./B2bFiltersCommercialRelation.vue?vue&type=script&lang=js"
export * from "./B2bFiltersCommercialRelation.vue?vue&type=script&lang=js"

import "./B2bFiltersCommercialRelation.vue?vue&type=style&index=0&id=8ad4b76e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ad4b76e"]])

export default __exports__